import {CONFIG_TYPE, OPERATIONS} from "../../util/Constants";
import {deepCopyObject} from "../../util/Util";

export const DraftSaveReducer = (state, action) => {
  const {data, stateKey, subKey, newInstance, keyComparator, valueComparator, allRowsAdded} = action.data;
  switch (action.type) {
    case 'SET_DATA': {
      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          [subKey]: {
            initialData: allRowsAdded ? state[stateKey][subKey].initialData : deepCopyObject(data),
            data: deepCopyObject(data)
          }
        }
      }
    }
    case 'RESET_DATA':
      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          [subKey]: {
            ...state[stateKey][subKey],
            data: deepCopyObject(state[stateKey][subKey].initialData)
          }
        }
      };
    case 'ADD_INSTANCE':
      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          [subKey] : {
            ...state[stateKey][subKey],
            data: [...state[stateKey][subKey].data, newInstance]
          }
        }
      };
    case 'EDIT_INSTANCE':
      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          [subKey]: {
            ...state[stateKey][subKey],
            data: state[stateKey][subKey].data.map((instance) => {
              if(keyComparator(newInstance, instance)) {
                let op = OPERATIONS.EDIT;
                if (valueComparator(newInstance, instance)) {
                  op = instance.operation
                } else if (instance.operation === OPERATIONS.ADD) {
                  op = OPERATIONS.ADD
                }
                if (op === OPERATIONS.EDIT)
                  return {...newInstance, operation: op, prev: instance};
                else
                  return {...newInstance, operation: op};
              }
              return instance;
            })
          }
        }
      };
    case 'DELETE_INSTANCE':
      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          [subKey]: {
            ...state[stateKey][subKey],
            data: state[stateKey][subKey].data
                .filter((instance) => {
                  if(keyComparator(instance)) {
                    return instance.operation !== OPERATIONS.ADD
                  }
                  return true;
                })
                .map((instance) => {
                  if(keyComparator(instance)) {
                    instance.operation = OPERATIONS.DELETE;
                  }
                  return instance;
                })
          }
        }
      };
    case 'DELETE_ALL':
      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          [subKey]: {
            ...state[stateKey][subKey],
            data: state[stateKey][subKey].data.map((instance) => ({...instance, operation: OPERATIONS.DELETE}))
          }
        }
      };
    default:
      return state;
  }
};

const initialState = {};

// Add state key in list for maintaining a new state
Object.values(CONFIG_TYPE).forEach((key) => {
  initialState[key] = {}
})

export {initialState};


// WEBPACK FOOTER //
// ./src/components/draftSave/reducers/DraftSaveReducer.js